import axiosInstance from "./AxiosInstance";

// Fase E-1 (2026-04-24) — novo fluxo de facturação Moloni.
// Endpoints documentados em develop/api/moloni-state.md.

export function getInvoiceOptions() {
  return axiosInstance.get(`/moloni/invoice-options`);
}

export function searchMoloniCustomers(q, limit = 20) {
  return axiosInstance.get(`/moloni/customers-search`, {
    params: { q, limit },
  });
}

export function listInvoiceableProducts(q = "", limit = 200) {
  return axiosInstance.get(`/moloni/invoiceable-products`, {
    params: { q, limit },
  });
}

export function createDraftInvoice(payload) {
  return axiosInstance.post(`/moloni/invoice/draft`, payload);
}

// E-3 — emissão com status (0=rascunho, 1=final) + try-fallback AT.
export function createInvoice(payload, { status = 0, allowATFallback = true } = {}) {
  return axiosInstance.post(`/moloni/invoice/create`, {
    ...payload,
    status,
    allow_at_fallback: allowATFallback,
  });
}

export function getInvoicePdfLink(documentId, { signed = 1 } = {}) {
  return axiosInstance.get(`/moloni/invoice/${documentId}/pdf`, {
    params: { signed },
  });
}

export function sendInvoiceEmail(documentId, payload) {
  return axiosInstance.post(`/moloni/invoice/${documentId}/send-email`, payload);
}

export function getMoloniInvoice(documentId) {
  return axiosInstance.get(`/moloni/invoice/${documentId}`);
}

export function updateMoloniInvoice(documentId, payload, { status = 0, allowATFallback = true } = {}) {
  return axiosInstance.post(`/moloni/invoice/${documentId}/update`, {
    ...payload,
    status,
    allow_at_fallback: allowATFallback,
  });
}

export function ensureFinalConsumer() {
  return axiosInstance.post(`/moloni/customer/final-consumer`);
}

export function lookupCustomerByVat(vat) {
  return axiosInstance.get(`/moloni/customer/by-vat`, { params: { vat } });
}

export function createMoloniCustomer(payload) {
  return axiosInstance.post(`/moloni/customer`, payload);
}

export function lookupVatInfo(vat, country = "PT") {
  return axiosInstance.get(`/moloni/vat-info`, {
    params: { vat, country },
  });
}

// Texto custom do email de facturação por empresa
export function getInvoiceEmailBody() {
  return axiosInstance.get(`/moloni/invoice-email-body`);
}

export function setInvoiceEmailBody(body) {
  return axiosInstance.post(`/moloni/invoice-email-body`, { body });
}

// Pending actions de stock (créditos/anulações que precisam decisão)
export function listStockPendingActions(status = "pending", opts = {}) {
  const params = { status };
  if (opts.includeRecentAuto) params.include_recent_auto = 1;
  return axiosInstance.get(`/moloni/stock-pending-actions`, { params });
}

export function resolveStockPendingAction(actionId, payload) {
  return axiosInstance.post(
    `/moloni/stock-pending-action/${actionId}/resolve`,
    payload,
  );
}

export function createMoloniProduct(payload) {
  return axiosInstance.post(`/moloni/product/create`, payload);
}

export function getProductCreationOptions() {
  return axiosInstance.get(`/moloni/product-creation-options`);
}

// Flow B — sincronização on-demand de peça TP → Moloni.
export function searchTpParts(q = "", limit = 30) {
  return axiosInstance.get(`/moloni/tp-parts/search`, {
    params: { q, limit },
  });
}

export function syncTpPartToMoloni(partId, { priceOverride, preservePrice = true } = {}) {
  return axiosInstance.post(`/moloni/tp-parts/${partId}/sync`, {
    price_override: priceOverride,
    preserve_price: preservePrice,
  });
}

// Refresh do cache `at_communicated` em m_document_set. Lento (~30s)
// pelo rate-limit Moloni — chamar em background.
export function refreshDocumentSetsAtStatus() {
  return axiosInstance.post(`/moloni/document-sets/refresh-at-status`);
}

export function refreshMoloniTaxes() {
  return axiosInstance.post(`/moloni/taxes/refresh`);
}

export function getCompanyTaxes() {
  return axiosInstance.get(`/moloni/taxes`);
}

export function getExemptionReasons() {
  return axiosInstance.get(`/moloni/exemption-reasons`);
}

export function getMoloniCustomerDetails(customerId) {
  return axiosInstance.get(`/moloni/customer/${customerId}/details`);
}

export function getMoloniDefaultSets() {
  return axiosInstance.get(`/moloni/default-sets`);
}

export function setMoloniDefaultSets(mapping) {
  return axiosInstance.post(`/moloni/default-sets`, {
    default_sets: mapping,
  });
}

// Lista facturas emitidas pelo TP com joins para nomes de cliente e
// série (endpoint novo E-3.1, /moloni/invoices). Status opcional.
export function listTpInvoices(params = {}) {
  return axiosInstance.get(`/moloni/invoices`, {
    params: {
      limit: 50,
      page: 1,
      ...params,
    },
  });
}
